import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

const getImageUrl = (image) => {
  if (!image) return null;

  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  const baseUrl = (
    process.env.REACT_APP_ASSET_URL ||
    process.env.REACT_APP_API_URL ||
    ""
  ).replace(/\/$/, "");

  return `${baseUrl}${image.startsWith("/") ? "" : "/"}${image}`;
};

const CategoryCard = ({ cat, navigate }) => {
  const imageUrl = getImageUrl(cat.image || cat.imageKey);
  const itemCount = Number(cat.count || cat._count?.products || 0);

  return (
    <motion.button
      type="button"
      onClick={() => navigate(cat.path || `/category/${cat.slug || cat.id}`)}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      className="group relative min-h-[210px] w-full overflow-hidden bg-slate-950 text-left sm:min-h-[270px]"
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={cat.name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition duration-700 ease-out group-hover:scale-105"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-primary-950 via-primary-800 to-[#b35a6e]">
          <span className="text-7xl font-semibold tracking-tight text-white/20">
            {cat.name?.charAt(0) || "C"}
          </span>
        </div>
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent" />
      <div className="absolute inset-0 bg-primary-950/0 transition duration-500 group-hover:bg-primary-950/20" />

      <div className="absolute inset-x-0 bottom-0 p-4 text-white sm:p-5">
        <div className="flex items-end justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-white/70">
              {itemCount > 0 ? `${itemCount} products` : "Explore collection"}
            </p>

            <h3 className="mt-1 truncate text-xl font-semibold tracking-[-0.025em] sm:text-2xl">
              {cat.name}
            </h3>
          </div>

          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/60 bg-white/10 text-white backdrop-blur-sm transition duration-300 group-hover:rotate-45 group-hover:bg-white group-hover:text-slate-950">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </div>
    </motion.button>
  );
};

export default CategoryCard;
